import React from 'react';

import { JZKRate } from '../types';
import { useTranslation } from '../utils/i18n';

import FlagIcon from './FlagIcon';
import TrendDownIcon from './TrendDownIcon';
import TrendStableIcon from './TrendStableIcon';
import TrendUpIcon from './TrendUpIcon';

interface JZKConverterProps {
  rates: JZKRate[];
}

const JZKConverter: React.FC<JZKConverterProps> = ({ rates }) => {
  const { t } = useTranslation();

  const getTrendIcon = (trend: 'rising' | 'falling' | 'same') => {
    if (trend === 'rising') return <TrendUpIcon />;
    if (trend === 'falling') return <TrendDownIcon />;
    return <TrendStableIcon />;
  };

  const getTrendClass = (trend: 'rising' | 'falling' | 'same') => {
    if (trend === 'rising') return 'trend-up';
    if (trend === 'falling') return 'trend-down';
    return 'trend-stable';
  };

  return (
    <div className="jzk-converter-section">
      <div className="jzk-converter-title">
        <h2>{t('title.main')}</h2>
      </div>

      <div className="jzk-rates-table-container">
        <table className="jzk-rates-table">
          <tbody>
            {rates.map((rate) => (
              <tr key={rate.code} className="jzk-rate-row">
                <td className="rate-country-cell">
                  <span className="rate-country-name">{t(rate.countryKey)}</span>
                  <FlagIcon code={rate.code} className="rate-flag-svg" />
                </td>
                <td className="rate-currency-cell">
                  {rate.amount} {rate.code}
                </td>
                <td className="rate-value-cell">
                  {rate.rate.toFixed(2).replace('.', ',')} CZK
                  <span className={`rate-trend ${getTrendClass(rate.trend)}`}>
                    {getTrendIcon(rate.trend)}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="jzk-table-footer">{t('footnote.xdr')}</div>
      </div>
    </div>
  );
};

export default JZKConverter;
